var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Complex } from '@syncfusion/ej2-base';
import { Border, Animation, Font } from '../../common/model/base';
import { Rect } from '@syncfusion/ej2-svg-base';
/**
 * Series class for the range navigator
 */
export class RangeNavigatorSeries extends ChildProperty {
    constructor() {
        super(...arguments);
        /** @private */
        this.clipRect = new Rect(0, 0, 0, 0);
    }
}
__decorate([
    Property(null)
], RangeNavigatorSeries.prototype, "dataSource", void 0);
__decorate([
    Property(null)
], RangeNavigatorSeries.prototype, "xName", void 0);
__decorate([
    Property(null)
], RangeNavigatorSeries.prototype, "yName", void 0);
__decorate([
    Property()
], RangeNavigatorSeries.prototype, "query", void 0);
__decorate([
    Property('Line')
], RangeNavigatorSeries.prototype, "type", void 0);
__decorate([
    Complex({ enable: false }, Animation)
], RangeNavigatorSeries.prototype, "animation", void 0);
__decorate([
    Complex({ color: 'transparent', width: 2 }, Border)
], RangeNavigatorSeries.prototype, "border", void 0);
__decorate([
    Property(null)
], RangeNavigatorSeries.prototype, "fill", void 0);
__decorate([
    Property(1)
], RangeNavigatorSeries.prototype, "width", void 0);
__decorate([
    Property(1)
], RangeNavigatorSeries.prototype, "opacity", void 0);
__decorate([
    Property('0')
], RangeNavigatorSeries.prototype, "dashArray", void 0);
/**
 * Thumb settings
 */
export class ThumbSettings extends ChildProperty {
}
__decorate([
    Property(null)
], ThumbSettings.prototype, "width", void 0);
__decorate([
    Property(null)
], ThumbSettings.prototype, "height", void 0);
__decorate([
    Complex({ width: 1, color: null }, Border)
], ThumbSettings.prototype, "border", void 0);
__decorate([
    Property(null)
], ThumbSettings.prototype, "fill", void 0);
__decorate([
    Property('Circle')
], ThumbSettings.prototype, "type", void 0);
/**
 * Style settings
 */
export class StyleSettings extends ChildProperty {
}
__decorate([
    Complex({}, ThumbSettings)
], StyleSettings.prototype, "thumb", void 0);
__decorate([
    Property(null)
], StyleSettings.prototype, "selectedRegionColor", void 0);
__decorate([
    Property(null)
], StyleSettings.prototype, "unselectedRegionColor", void 0);
/*
 * Configures the ToolTips in the chart.
 */
export class RangeTooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], RangeTooltipSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], RangeTooltipSettings.prototype, "opacity", void 0);
__decorate([
    Property(null)
], RangeTooltipSettings.prototype, "fill", void 0);
__decorate([
    Property(null)
], RangeTooltipSettings.prototype, "format", void 0);
__decorate([
    Complex({ fontFamily: null, size: '12px', fontStyle: 'Normal', fontWeight: null, color: null }, Font)
], RangeTooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], RangeTooltipSettings.prototype, "template", void 0);
__decorate([
    Complex({ color: null, width: null }, Border)
], RangeTooltipSettings.prototype, "border", void 0);
__decorate([
    Property('OnDemand')
], RangeTooltipSettings.prototype, "displayMode", void 0);
